import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAdd = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.55556 3.55556C8.55556 3.40821 8.49702 3.26691 8.39284 3.16272C8.28865 3.05853 8.14734 3 8 3C7.85266 3 7.71135 3.05853 7.60716 3.16272C7.50298 3.26691 7.44444 3.40821 7.44444 3.55556V7.44444H3.55556C3.40821 7.44444 3.26691 7.50298 3.16272 7.60716C3.05853 7.71135 3 7.85266 3 8C3 8.14734 3.05853 8.28865 3.16272 8.39284C3.26691 8.49702 3.40821 8.55556 3.55556 8.55556H7.44444V12.4444C7.44444 12.5918 7.50298 12.7331 7.60716 12.8373C7.71135 12.9415 7.85266 13 8 13C8.14734 13 8.28865 12.9415 8.39284 12.8373C8.49702 12.7331 8.55556 12.5918 8.55556 12.4444V8.55556H12.4444C12.5918 8.55556 12.7331 8.49702 12.8373 8.39284C12.9415 8.28865 13 8.14734 13 8C13 7.85266 12.9415 7.71135 12.8373 7.60716C12.7331 7.50298 12.5918 7.44444 12.4444 7.44444H8.55556V3.55556Z",
		fill: "currentColor"
	})
});
export default SvgAdd;
